import React, { useState, type ChangeEvent, type FormEvent } from "react";
import { formatPhoneWithCountryCode } from "../../../utils";
import { Link } from "react-router-dom";

interface ContactProps {
  data?: {
    name: string;
    address: string;
    phone: string;
    email: string;
  };
}
interface FormState {
  name: string;
  email: string;
  message: string;
  website: string;
}
const initialState = { name: "", email: "", message: "", website: "" };

export const Contact: React.FC<ContactProps> = ({ data }) => {
  const [form, setForm] = useState<FormState>(initialState);
  const [status, setStatus] = useState<{
    type: "idle" | "loading" | "success" | "error";
    message: string;
  }>({ type: "idle", message: "" });
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (status.type === "loading") return;

    setStatus({ type: "loading", message: "Enviando mensagem..." });

    const serverUrl = (process.env.REACT_APP_SRV_URL ?? "").trim();
    const apiPath = (process.env.REACT_APP_API_PATH ?? "").trim();
    const baseUrl = `${serverUrl}${apiPath}`;

    if (!serverUrl) {
      setStatus({
        type: "error",
        message: "Servidor indisponivel no momento.",
      });
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
          website: form.website,
        }),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        const serverMessage = Array.isArray(payload?.message)
          ? payload.message.join(" ")
          : payload?.message;
        setStatus({
          type: "error",
          message:
            serverMessage ||
            "Nao foi possivel enviar sua mensagem. Tente novamente.",
        });
        return;
      }

      setForm(initialState);
      setStatus({
        type: "success",
        message: "Mensagem enviada. Em breve entraremos em contato.",
      });
    } catch {
      setStatus({
        type: "error",
        message: "Nao foi possivel enviar sua mensagem. Tente novamente.",
      });
    }
  };

  const isLoading = status.type === "loading";

  return (
    <section id="contato" className="relative py-24">
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-blue-50 via-white to-cyan-50" />
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          {/* Form */}
          <div className="rounded-3xl border border-slate-200/70 bg-white/95 p-8 shadow-soft">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-blue-600">
              Contato
            </p>
            <h2 className="mt-3 text-3xl font-semibold text-slate-900">
              Vamos identificar onde a IA pode gerar mais resultado?
            </h2>
            <p className="mt-4 text-slate-600">
              Conte brevemente como sua empresa atende hoje. Na demonstração,
              mostramos como a Sengia pode apoiar o seu fluxo real.
            </p>
            <form onSubmit={handleSubmit} className="mt-8 space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <input
                  name="name"
                  type="text"
                  placeholder="Nome"
                  required
                  minLength={2}
                  maxLength={80}
                  autoComplete="name"
                  value={form.name}
                  onChange={handleChange}
                  className="form-input rounded-xl px-4 py-3"
                />
                <input
                  name="email"
                  type="email"
                  placeholder="Email"
                  required
                  maxLength={120}
                  autoComplete="email"
                  value={form.email}
                  onChange={handleChange}
                  className="form-input rounded-xl px-4 py-3"
                />
              </div>
              <input
                name="website"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                value={form.website}
                onChange={handleChange}
                className="hidden"
                aria-hidden="true"
              />
              <textarea
                name="message"
                rows={4}
                placeholder="Conte o que você gostaria de automatizar"
                required
                minLength={10}
                maxLength={2000}
                value={form.message}
                onChange={handleChange}
                className="form-textarea rounded-xl px-4 py-3"
              />
              <button
                type="submit"
                disabled={isLoading}
                className="btn btn-neutral rounded-full px-6 py-3"
              >
                {isLoading ? "Enviando..." : "Quero conhecer a Sengia"}
              </button>
              {status.type !== "idle" && (
                <p
                  className={`text-sm ${
                    status.type === "success"
                      ? "text-emerald-600"
                      : status.type === "error"
                        ? "text-rose-600"
                        : "text-slate-500"
                  }`}
                  role="status"
                  aria-live="polite"
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>
          {/* Contatos */}
          {/* <div className="space-y-6">
            <div className="rounded-2xl border border-slate-200/70 bg-white/95 p-6 shadow-soft">
              <h3 className="text-xl font-semibold text-slate-900">
                Informações de contato
              </h3>
              <div className="mt-4 space-y-3 text-sm text-slate-600">
                <p className="flex items-start gap-3">
                  <i className="fa fa-user mt-1 text-blue-500"></i>
                  {data?.name ?? "loading"}
                </p>
                <p className="flex items-start gap-3">
                  <i className="fa fa-map-marker mt-1 text-blue-500"></i>
                  {data?.address ?? "loading"}
                </p>
                <p className="flex items-start gap-3">
                  <i className="fa fa-phone mt-1 text-blue-500"></i>
                  {data?.phone
                    ? formatPhoneWithCountryCode(data.phone)
                    : "loading"}
                </p>
                <p className="flex items-start gap-3">
                  <i className="fa fa-envelope-o mt-1 text-blue-500"></i>
                  {data?.email ?? "loading"}
                </p>
              </div>
            </div>
          </div> */}
        </div>
        <footer className="mt-12 text-center text-sm text-slate-500">
          <p>&copy; 2026 Sengia - Todos os direitos reservados</p>
          <Link
            className="mt-2 inline-block text-blue-600 hover:underline"
            to="/politica-de-privacidade"
          >
            Política de Privacidade
          </Link>
        </footer>
      </div>
    </section>
  );
};
